module.exports = __webpack_public_path__ + "static/dinner-7d58a2138d75ef0d31b79f21a389b24d.jpeg";